import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

export const Paginate = (WrappedComponent) => {
  class PaginateWrapper extends WrappedComponent {
    constructor(props) {
      super(props);
      this.onScroll = this.onScroll.bind(this);
      this.setRef = this.setRef.bind(this);
    }

    onScroll() {
      const { hasMore, loading, loadMoreItems } = this.props;

      if (!hasMore) return;
      const itemComponent = this.refNode;
      const itemDomNode = ReactDOM.findDOMNode(itemComponent);
      const itemPosition = itemDomNode.getBoundingClientRect();
      const scrollNearLastItem = (window.innerHeight) >= (itemPosition.bottom - 50);

      if (scrollNearLastItem && !loading) {
        loadMoreItems();
      }
    }

    setRef(node) {
      // if ref callback gets called with null it is unmounting or in preliminary stages so remove eventlistener
      // when it has props the node exists and we can set the ref and eventlistener
      if (!node) {
        window.removeEventListener('scroll', this.onScroll, false);
      } else if (node.props) {
        window.addEventListener('scroll', this.onScroll, false);
        this.refNode = node;
      }
    }

    render() {
      return <WrappedComponent {...this.props} ref={this.setRef} />;
    }
  }

  PaginateWrapper.propTypes = {
    hasMore: PropTypes.bool,
    loading: PropTypes.bool,
    loadMoreItems: PropTypes.func,
  };

  return PaginateWrapper;
};
